export default function slugify(string) {
  const a = "àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;";
  const b = "aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------";
  const p = new RegExp(a.split("").join("|"), "g");
  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, "-and-") // Replace & with ‘and’
    .replace(/[^\w\\-]+/g, "") // Remove all non-word characters
    .replace(/\\-\\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}

export function productSearchUrl(value) {
  return "/producten/zoeken?" + new URLSearchParams({ q: value }).toString();
}

export function productSearchTerm(location, match) {
  if (location && location.pathname === "/producten/zoeken") {
    return new URLSearchParams(location.search).get("q") || "";
  }

  if (
    match &&
    match.path === "/producten/zoeken/:val" &&
    match.params &&
    match.params.val != null
  ) {
    try {
      return decodeURIComponent(match.params.val);
    } catch (e) {
      return match.params.val;
    }
  }

  return null;
}
